import {
  ADD_NOTIF_REF,
  UPDATE_NOTIF_REF,
  GET_NEXT_NOTIFS,
  GET_NOTIF_DATA_FROM_REFERENCE,
  SET_NOTIF_DATA,
  UPDATE_NOTIFS_DATA,
  MERGE_NOTIF,
  MERGE_NOTIF_DATA,
  UPDATE_NOTIFS_DATES,
  UPDATE_NOTIFS_PUBLISHED_AT,
  REFRESH_NOTIFS_PUBLISHED_AT,
  SET_NOTIF_READ,
  SAVE_NOTIF_READ,
  DELETE_NOTIF,
  RESET_NOTIFS_ACTION,
  CALC_BADGE,
  SAVE_BADGE,
  RESET_NOTIFS
} from '../actions/notificationQueries'
import firebase from 'firebase'
import { _ } from 'vue-underscore'
import { RegisterEvent } from '../../analytics'
import { notifDB, userDB } from '../../firestoreDB'
import { updateBadge, isApp } from '@/utils/ReactNative'
import { getUserNotifsRefsPage } from '@/helper/paginate'
import { docToNotifRef, docToNotifData } from '@/converters/notifConverter'
import {
  getIndexForNewItem,
  getIndexForItem,
  addListItem
} from '@/helper/helper'

const getDefaultState = () => ({
  notifsData: [],
  notifsRefs: [],
  notifBadge: 0,
  badgeSent: false,
  lastNotifPublishedAt: new Date().getTime() / 1000
})

const state = getDefaultState()

const getters = {
  getNotifsData: state => _.compact(state.notifsData),
  getNotifsRefs: state => state.notifsRefs,
  getLastNotifPublishedAt: state => state.lastNotifPublishedAt,
  getBadgeNotif: state => state.notifBadge,
  getCheckedBadge: state => state.badgeSent
}
const actions = {
  [GET_NEXT_NOTIFS]: ({ getters, dispatch, commit }) => {
    return new Promise(resolve => {
      const last = _.last(getters.getNotifsRefs)
      const source = getUserNotifsRefsPage(last && last.score)
      source.onSnapshot({ includeMetadataChanges: true }, snapshot => {
        snapshot.docChanges().forEach(docChanged => {
          const doc = docChanged.doc
          let notifRef = null
          switch (docChanged.type) {
            case 'added':
              notifRef = docToNotifRef(doc)
              commit(ADD_NOTIF_REF, notifRef)
              dispatch(GET_NOTIF_DATA_FROM_REFERENCE, notifRef)
              break
            case 'modified':
              notifRef = docToNotifRef(doc)
              commit(UPDATE_NOTIF_REF, notifRef)
              break
            case 'removed':
              commit(DELETE_NOTIF, doc.id)
              break
            default:
              break
          }
        })
        resolve(true)
      })
    })
  },
  [GET_NOTIF_DATA_FROM_REFERENCE]: ({ commit, dispatch, getters }, item) => {
    notifDB
      .where(firebase.firestore.FieldPath.documentId(), '==', item.key)
      .onSnapshot({ includeMetadataChanges: true }, snapshotDoc => {
        snapshotDoc.docChanges().forEach(docChanged => {
          const doc = docChanged.doc
          let notifData = null
          switch (docChanged.type) {
            case 'added':
              notifData = docToNotifData(doc, item)
              commit(SET_NOTIF_DATA, notifData)
              dispatch(UPDATE_NOTIFS_DATES)
              break
            case 'modified':
              notifData = docToNotifData(doc, item)
              commit(SET_NOTIF_DATA, notifData)
              dispatch(UPDATE_NOTIFS_DATES)
              break
            case 'removed':
              commit(DELETE_NOTIF, doc.id)
              break
            default:
              break
          }
        })
      })
  },
  [UPDATE_NOTIFS_DATES]: ({ commit, getters }) => {
    const twoDaysInSeconds = 172800
    const minute = 60
    const todaySeconds = new Date().getTime() / 1000 // today seconds
    if (todaySeconds - getters.getLastNotifPublishedAt > minute) {
      getters.getNotifsData.map((item, index) => {
        if (item) {
          let seconds = item.published_at.seconds
          const diff = todaySeconds - seconds
          if (diff <= twoDaysInSeconds) {
            commit(REFRESH_NOTIFS_PUBLISHED_AT, { item, index })
          } else return true
        }
      })
      commit(UPDATE_NOTIFS_PUBLISHED_AT, todaySeconds)
    }
  },
  [CALC_BADGE]: ({ commit, getters }) => {
    return new Promise(resolve => {
      userDB
        .doc(getters.firebaseUUID())
        .collection('notifications')
        .where('read', '==', false)
        .onSnapshot({ includeMetadataChanges: true }, snapshot => {
          snapshot.docChanges().forEach(docChanged => {
            let badge = getters.getBadgeNotif
            if (docChanged.type === 'added') commit(SAVE_BADGE, ++badge)
            if (docChanged.type === 'removed') commit(SAVE_BADGE, --badge)
          })
          resolve(true)
        })
    })
  },
  [SET_NOTIF_READ]: ({ commit, getters }, keyNotif) => {
    const { key } = keyNotif
    RegisterEvent('chi_notification_read', {
      target_id: key,
      target_type: 'notification_id'
    })
    userDB
      .doc(getters.firebaseUUID())
      .collection('notifications')
      .doc(key)
      .update({ read: true })
      .then(() => {
        commit(SAVE_NOTIF_READ, key)
      })
  },
  [RESET_NOTIFS_ACTION]: ({ commit }) => {
    commit(RESET_NOTIFS)
  },
  [MERGE_NOTIF]: ({ commit }, value) => {
    commit(MERGE_NOTIF_DATA, value)
  }
}

const mutations = {
  [ADD_NOTIF_REF]: (state, elemRef) => {
    const newIndexRef = getIndexForNewItem(
      state.notifsRefs,
      'score',
      elemRef.score
    )
    state.notifsRefs.splice(newIndexRef, 0, elemRef)
    state.notifsData.splice(newIndexRef, 0, null)
  },
  [UPDATE_NOTIF_REF]: (state, elemRef) => {
    const oldIndexRef = getIndexForItem(state.notifsRefs, 'key', elemRef.key)
    const oldElemeRef = state.notifsRefs[oldIndexRef]
    let elemData = null
    let newIndexRef = -1
    let hasIndexChanged = oldElemeRef.score !== elemRef.score
    if (hasIndexChanged) {
      newIndexRef = getIndexForNewItem(state.notifsRefs, 'score', elemRef.score)
      hasIndexChanged = newIndexRef !== oldIndexRef
    }
    if (hasIndexChanged) {
      state.notifsRefs.splice(oldIndexRef, 1)
      let elemDataList = state.notifsData.splice(oldIndexRef, 1)
      elemData = elemDataList[0] || null
      newIndexRef = newIndexRef > oldIndexRef ? newIndexRef - 1 : newIndexRef // Testear
      state.notifsRefs = addListItem(
        [...state.notifsRefs],
        elemRef,
        newIndexRef
      )
      elemData = elemData ? { ...elemData, ...elemRef } : elemData
      state.notifsData = addListItem(
        [...state.notifsData],
        elemData,
        newIndexRef
      )
    } else {
      state.notifsRefs[oldIndexRef] = elemRef
      let notifsData = state.notifsData
      elemData = notifsData[oldIndexRef]
      elemData = elemData ? { ...elemData, ...elemRef } : elemData
      notifsData[oldIndexRef] = elemData
      state.notifsData = [...notifsData]
    }
  },
  [SET_NOTIF_DATA]: (state, elemData) => {
    const index = getIndexForItem(state.notifsRefs, 'key', elemData.key)
    if (index > -1) {
      let notifsData = [...state.notifsData]
      notifsData[index] = elemData
      state.notifsData = notifsData
    }
  },
  [UPDATE_NOTIFS_DATA]: (state, value) => {
    state.notifsData[value.index] = value
  },
  [SAVE_BADGE]: (state, value) => {
    state.notifBadge = value
    state.badgeSent = true
    isApp && updateBadge(value)
  },
  [MERGE_NOTIF_DATA]: (state, value) => {
    const { key, data } = value
    let notifElement = _.findWhere(state.notifsData, { key: key })
    if (_.size(notifElement) > 0) {
      notifElement.like = data.like
      state.notifsData[notifElement.index] = notifElement
    }
  },
  [REFRESH_NOTIFS_PUBLISHED_AT]: (state, { item, index }) => {
    state.notifsData[index] = {
      ...state.notifsData[index],
      published_at: item.published_at,
      moment: Math.random()
    }
  },
  [UPDATE_NOTIFS_PUBLISHED_AT]: (state, dateTimeSeconds) => {
    state.lastNotifPublishedAt = dateTimeSeconds
  },
  [SAVE_NOTIF_READ]: (state, key) => {
    const index = getIndexForItem(state.notifsRefs, 'key', key)
    state.notifsRefs[index].read = true
    state.refNotifications = [...state.notifsRefs]
  },
  [DELETE_NOTIF]: (state, key) => {
    const postIndex = getIndexForItem(state.notifsRefs, 'key', key)
    if (postIndex > -1) {
      state.notifsRefs.splice(postIndex, 1)
      state.notifsData.splice(postIndex, 1)
    }
  },
  [RESET_NOTIFS]: state => {
    Object.assign(state, getDefaultState())
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notificationQuery.js